import React from 'react';
import PropTypes from 'prop-types';

export default function Snow(props) {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.7943 3V21M14.1134 4.92868C13.4135 5.35053 12.6115 5.57285 11.7943 5.57154C10.9771 5.57285 10.1751 5.35053 9.47517 4.92868M9.47517 19.0716C10.1756 18.6509 10.9772 18.4287 11.7943 18.4287C12.6113 18.4287 13.413 18.6509 14.1134 19.0716M19.5885 7.5L4 16.5M19.0774 10.4733C18.3628 10.0769 17.7694 9.49361 17.361 8.78583C16.9525 8.07804 16.7443 7.27246 16.7587 6.45539M4.51112 13.5267C5.22577 13.923 5.81912 14.5064 6.22758 15.2141C6.63604 15.9219 6.84423 16.7275 6.82983 17.5446M4 7.5L19.5885 16.5M4.51112 10.4733C5.22577 10.0769 5.81912 9.49361 6.22758 8.78583C6.63604 8.07804 6.84423 7.27246 6.82983 6.45539M19.0774 13.5267C18.3628 13.923 17.7694 14.5064 17.361 15.2141C16.9525 15.9219 16.7443 16.7275 16.7587 17.5446"
        stroke={props.color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

Snow.defaultProps = {
  color: '#fff'
};

Snow.propTypes = {
  color: PropTypes.string
};
